<div #textCollapse class="p-relative">
  <ng-container *ngIf="isCollapsed; else elseTemplate">
    <div
      *ngFor="let line of linedContent; let i = index"
      class="p-text-left nowrap"
    >{{ line }}
      <a
        *ngIf="isCollapsed && isContentOverflow && i + 1 === linedContent.length"
        class="text-collapse-more-less"
        (click)="setIsCollapsed(false)"
        >...{{ "SigvLibrary.more" | translate }}</a
      >
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div
      class="p-text-left"
      [ngClass]="{
        'p-white-space-pre-line': customBreakLine,
        'line-break-anywhere': customBreakLine,
        'pre-wrap': !customBreakLine
      }"
    >{{ customBreakLine ? customBreakLineText : innerText }}
      <a
        *ngIf="!isCollapsed"
        class="text-collapse-more-less"
        (click)="setIsCollapsed(true)"
        >{{ "SigvLibrary.Less" | translate }}</a
      >
    </div>
  </ng-template>

  <!-- div for measuring content -->
  <div
    class="measuring-content"
    [ngClass]="{
      'line-break-anywhere': customBreakLine,
      'pre-wrap': !customBreakLine
    }"
  ><div #measuredDiv>{{ innerText }}</div>
  </div>

  <!-- div for measuring more text -->
  <div class="measuring-content nowrap">
    <div #measuredMoreDev></div>
  </div>
</div>
